import React from 'react';
import styled, { keyframes, css } from 'styled-components';

import { colors, neumorphism } from './constant';
import { respondTo } from './responsive';

const Label = styled.span`
    display: inline-block;

    padding: 8px 0;
    margin-left: 16px;
    margin-right: 40px;

    font-size: 16px;
    font-weight: 700;
    color: ${ colors.label1 };

    ${ respondTo.lg } {
        margin-left: 0;
        margin-bottom: 8px;
        font-size: 14px;
    }
`

const FilterSplitLine = styled.span`
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: ${ colors.stroke };
    margin: 0 12px;
    margin-right: 24px !important;

    ${ respondTo.md } {
        display: none;
    }
`

const createCss = () => {
    let style = '';
    (new Array(10)).fill().forEach((_, i) => {
        style += `.mb-${i+1} { margin-bottom: ${(i+1)*8}px; } `;
        style += `.mt-${i+1} { margin-top: ${(i+1)*8}px; } `;
        style += `.mr-${i+1} { margin-right: ${(i+1)*8}px; } `;
        style += `.ml-${i+1} { margin-left: ${(i+1)*8}px; } `;
    });
    return style;
}

const DivWithLayoutTools = styled.div`
    ${ createCss() };

    .d-flex {
        display: flex;

        &.gap { gap: 8px; }
        &.justify-between { 
            justify-content: space-between; 
            ${ respondTo.md } {
                justify-content: flex-start;
                flex-direction: column;
                align-items: flex-start !important;
            }
        }
        &.justify-end { justify-content: flex-end; }
        &.align-center { align-items: center; }
    }
`;

const FilterListRoot = styled.div`
    display: flex;

    ${({borderBottom}) => borderBottom && css`
        ${'' /* border-bottom: 1px solid ${ colors.stroke }; */}
        margin-bottom: 12px;
    `}

    ${ respondTo.lg } {
        flex-direction: column;
    }
`

const FilterListContainer = styled.div`
    display: flex;

    align-items: center;
    flex-wrap: wrap;
    flex: 1;

    ${ respondTo.lg } {
        
    }

    >* {
        margin-right: 12px;
        margin-bottom: 12px;

        ${({noMarginBottom}) => noMarginBottom && css`
            margin-bottom: 0px;

            ${ respondTo.md } {
                margin-bottom: 12px;
            }
        `}
    }
`

const FilterList = ({ label, children, className, borderBottom, noMarginBottom }) => (
    <FilterListRoot className={className} borderBottom={borderBottom}>
        <Label>{ label }</Label>
        <FilterListContainer noMarginBottom={noMarginBottom}>
            { children }
        </FilterListContainer>
    </FilterListRoot>
)

const StateIndicator = styled.div`

    color: ${ colors.text };
    font-size: 18px;
    font-weight: 500;
    text-align: center;

    padding: 24px 0;
    border-radius: 16px;

    background-color: ${ colors.bgDepth1 };
    ${ neumorphism.convex };
`

const loadingAnimation = keyframes`
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
`

const LoadingIndicatorRoot = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    color: ${ colors.text };
    font-size: 18px;
    font-weight: 500;

    .lds-ripple {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
    }
    .lds-ripple div {
        position: absolute;
        border: 4px solid ${ colors.text };
        opacity: 1;
        border-radius: 50%;
        animation: ${loadingAnimation} 1.6s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    }
    /* .lds-ripple div:nth-child(2) {
        animation-delay: -0.25s;
    } */
    .lds-ripple div:nth-child(2) {
        animation-delay: -0.5s;
    }
`

const LoadingIndicator = () => (
    <LoadingIndicatorRoot>
        <div className="lds-ripple"><div></div><div></div></div>
        Loading ...
    </LoadingIndicatorRoot>
)



export { Label, DivWithLayoutTools, FilterSplitLine, FilterList, StateIndicator, LoadingIndicator };